module.exports = __webpack_public_path__ + "static/media/googlecloud.6beccf3c.svg";